import React from "react";
import { Box } from "@chakra-ui/react";
import { RadialGradient } from "ui/radial-gradient";

export function HeroGradient() {
  return (
    <>
      <Box
        bg="linear-gradient(180deg, var(--chakra-colors-mint) -78.7%, rgba(64, 227, 152, 0.00) 85.54%)"
        pos="absolute"
        top="-15%"
        right={0}
        left={0}
        h={{ base: "52%", lg: "70%" }}
        opacity={{ base: 0.7, lg: 0.5 }}
      />
      <RadialGradient
        variant="mint"
        top="-60%"
        left="-20%"
        w="90%"
        h={{ base: "76%", lg: "88%" }}
        opacity={{ base: 1, lg: 0.8 }}
      />
      <RadialGradient
        variant="lightspeed"
        top={{ base: "-58%", lg: "-50%" }}
        right="-20%"
        w="90%"
        h="65%"
        opacity={{ base: 1, lg: 0.8 }}
      />
      <RadialGradient
        variant="cyan"
        top="-40%"
        right="-40%"
        w="70%"
        h={{ base: "60%", lg: "70%" }}
        opacity={{ base: 1, lg: 0.9 }}
      />
    </>
  );
}
